import { Component, inject, output,viewChild } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { IconComponent } from '@banyan/commons/components/icon/icon.component';
import { FRAGRANCES_LINKS } from '@banyan/commons/consts/links.const';
import { FeatureTogglingDirective } from '@banyan/commons/directives/feature-toggling.directive';
import { ImgFallbackDirective } from '@banyan/commons/directives/src-fallback.directive';
import { SimpleLink } from '@banyan/commons/models/simple-link.model';
import { AccountService } from '@banyan/features/account/services/account.service';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-header-navbar',
  templateUrl: './header-navbar.component.html',
  styleUrls: ['./header-navbar.component.scss'],
  imports: [
    IconComponent,
    RouterLink,
    ImgFallbackDirective,
    RouterLinkActive,
    TranslatePipe,
    MatMenuModule,
    MatIconModule,
    FeatureTogglingDirective,
  ],
  standalone: true,
})
export class HeaderNavbarComponent {
  readonly sideNavToggle = output<boolean>();
  readonly menuTrigger = viewChild.required(MatMenuTrigger);
  router = inject(Router);
  accountService = inject(AccountService);

  fragrancesLinks: SimpleLink[] = FRAGRANCES_LINKS;

  openSidenav() {
    this.sideNavToggle.emit(true);
  }

  goToLink(url: string, event: any): void {
    event.stopPropagation();
    this.menuTrigger().closeMenu();
    this.router.navigate([url]).then();
  }
}
